import * as React from "react"
import { DatePickerSeeker } from "@ui-seeker/core"

import {currentSingleDate} from "@signals";


export default function DIPCurrentSingleDatePicker({ ...props }) {
    return <DatePickerSeeker
        label="Current Date"
        value={currentSingleDate.value}
        onChange={e => currentSingleDate.value = e}
        {...props}
    />
}